// Screen headings only. Metric values keep their existing definitions.
import { withoutUzsLabel } from "./currencyLabels";
const headings = {
  tr: { sales: "Satış", basket: "Sepet Ort.", unitPrice: "Birim Fiyat", receipts: "Müşteri (Fiş)", units: "Adet", salesChange: "LY Satış Değişim %", previous: "LY", change: "Değişim %", total: "Toplam", campaign: "Kampanyalı" },
  en: { sales: "Sales", basket: "Avg. Basket", unitPrice: "Unit Price", receipts: "Customer (Receipt)", units: "Units", salesChange: "LY Sales Change %", previous: "LY", change: "Change %", total: "Total", campaign: "Campaign" },
  ru: { sales: "Продажи", basket: "Средний чек", unitPrice: "Цена за шт.", receipts: "Покупатель (чек)", units: "Шт.", salesChange: "Изменение продаж LY %", previous: "LY", change: "Изменение %", total: "Всего", campaign: "По акции" },
  uz: { sales: "Savdo", basket: "O‘rtacha chek", unitPrice: "Dona narxi", receipts: "Mijoz (chek)", units: "Dona", salesChange: "LY savdo o‘zgarishi %", previous: "LY", change: "o‘zgarishi %", total: "Jami", campaign: "Aksiyali" },
};
export type ScreenMetric = "sales" | "basket" | "unitPrice" | "receipts" | "units" | "salesChange";
const metricFor: Record<string, ScreenMetric> = {
  sales: "sales", lySales: "sales", previousSales: "sales", campaignSales: "sales",
  basket: "basket", atv: "basket", previousAtv: "basket", atvChange: "basket",
  unit: "unitPrice", unitPrice: "unitPrice", avp: "unitPrice", previousAvp: "unitPrice", lyUnitPrice: "unitPrice", avpChange: "unitPrice", unitPriceChange: "unitPrice",
  receipts: "receipts", lyReceipts: "receipts", previousReceipts: "receipts", campaignReceipts: "receipts", receiptsChange: "receipts",
  units: "units", lyUnits: "units", previousUnits: "units", campaignUnits: "units", unitsChange: "units",
  salesChange: "salesChange",
};
export function isScreenMetric(key: string) { return Object.hasOwn(metricFor, key); }
export function metricScreenHeading(metric: ScreenMetric, language: string) {
  return (headings[language as keyof typeof headings] ?? headings.tr)[metric];
}
export function screenMetricColumnLabel(key: string, original: string, language: string, override?: ScreenMetric) {
  const metric = override ?? metricFor[key];
  if (!metric) return withoutUzsLabel(original);
  const c = headings[language as keyof typeof headings] ?? headings.tr;
  if (key === "salesChange") return c.salesChange;
  const base = c[metric];
  if (key.endsWith("Change")) return `${c.previous} ${base} ${c.change}`;
  const year = original.match(/\b20\d{2}\b/)?.[0];
  const previous = /^(ly|previous)/.test(key);
  const scope = key.startsWith("campaign") ? c.campaign
    : /^(Toplam|Total|Всего|Jami)(?:\s|$)/u.test(original) ? c.total : "";
  return [scope || (previous && !year ? c.previous : ""), base, year].filter(Boolean).join(" ");
}
export function screenMetricColumns<T extends { key: string; label: string; screenMetric?: ScreenMetric }>(columns: T[], language: string) {
  return columns.map(column => {
    const label = screenMetricColumnLabel(column.key, column.label, language, column.screenMetric);
    return { ...column, label, wrapHeaderText: label !== column.label };
  });
}
